import { ReactComponent as Icon } from "../icons/archives.svg";

const Archives = ({color, wth}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, marginTop: "3px"})} />
    </div>
  );
};

export default Archives;